import { EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'
import { AIButton } from '../AIButton'
import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'

import * as styles from './AIButtonContainedGrey.module.css'

function AIButtonContainedGrey({
  beforeIconProps: {
    height: beforeIconHeight = ICON_HEIGHT_20,
    ...beforeIconProps
  } = EMPTY_OBJECT,
  className = styles.aiButtonContainedGrey,
  height = BUTTON_HEIGHT_32,
  textClassName = styles.label,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button.Contained}
      beforeIconProps={{ ...beforeIconProps, height: beforeIconHeight }}
      className={className}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.ContainedGrey}
      height={height}
      textClassName={textClassName}
    />
  )
}

export default AIButtonContainedGrey
